<template>

  <div v-loading="loading" class="py-4 mt-6 container-fluid">

    <div class="row">

      <div class="col-lg-5 col-12">

        <div class="row">

          <div class="col-lg-6 col-md-6 col-12">

            <mini-statistics-card :title="$t('policyInsuredsAlt')" :value-text="totalInsureds" value="" :icon="{

              component: 'bi bi-person-check-fill',

              background: 'bg-gradient-dark',

            }" class-content="ms-3" />

            <mini-statistics-card :title="$t('policyRequestsTotal')" :value-text="requestsCount" value="" :icon="{

              component: 'bi bi-envelope-arrow-up-fill',

              background: 'bg-gradient-dark',

            }" class-content="ms-3" />

          </div>

          <div class="col-lg-6 col-md-6 col-12">

            <mini-statistics-card :title="$t('commonStartDate')" :value-text="formatDate(policy.startDate)" value=""

              :percentage="{

                value: '+12%',

                color: 'text-success',

              }" :icon="{

                component: 'bi bi-calendar-fill',

                background: 'bg-gradient-dark',

              }" class-content="ms-3" />



            <mini-statistics-card :title="$t('commonEndDate')" :value-text="formatDate(policy.endDate)" value=""

              :percentage="{

                value: '+12%',

                color: 'text-success',

              }" :icon="{

                component: 'bi bi-calendar-fill',

                background: 'bg-gradient-dark',

              }" class-content="ms-3" />

          </div>

        </div>

      </div>

      <div class="col-lg-3 col-12 mt-lg-0">

        <gauge-chart />

      </div>

      <div class="col-lg-4 col-12 mt-lg-0">

        <progress-line-chart :title="$t('referrals')" :count="totalClaim" :chart="claimLineChart" />

      </div>

    </div>

    <div class="mt-4 row">

      <div v-loading="loadingTable" class="col-lg-8 col-12">

        <div class="card soft-card soft-table-card">

          <div class="soft-card-header">

            <h6 class="mb-0">{{ $t("policyInsureds") }}</h6>

          </div>

          <div class="card-body policy-insureds-table__body">

              <insureds-table :current-page="page" :page="page" :is-short="true" :max-row="maxRow" :table-data="insureds"
                :insured-count="insuredCount" @excel="openExcelPreview" @get-table="handleSearch"></insureds-table>

          </div>

        </div>

      </div>

      <div class="col-lg-4 col-12 mt-lg-0">

        <div class="policy-side-stack">

          <progress-doughnut-chart :title="$t('policyReferralTypes')" :count="doughnutHasData ? perVal().toFixed(2) + '%' : ''" :chart="doughnutChartConfig" />

          <bar-chart :chart="barChartPrimary" :chart2="barChartSecondary" />

          <request-table :data-table="requests"></request-table>

        </div>

      </div>

    </div>

  </div>

  <InsuredExportPreviewDialog
    v-model="exportPreviewVisible"
    :rows="exportPreviewRows"
    :file-name="exportFileName"
    :exporting="exportingExcel"
    @export="confirmExcelExport"
  />

</template>



<script>
import { getPolicyId, groupClinicHref } from "@/project/Source/routes";


import GaugeChart from "./components/GaugeChart.vue";

import { exportStyledTableWorkbook, mapInsuredRowsForExport } from "@/project/Source/excelExport.js";

import RequestTable from "./components/RequestTable.vue";

import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";

import ProgressLineChart from "./components/ProgressLineChart.vue";

import ProgressDoughnutChart from "./components/ProgressDoughnutChart.vue";

import BarChart from "./components/BarChart.vue";

import image from "@/assets/img/team-3.jpg";

import Source from "@/project/Source/claim.js";

import InsuredsTable from "@/project/Global/Tables/InsuredsTable.vue";
import InsuredExportPreviewDialog from "@/project/Global/Components/InsuredExportPreviewDialog.vue";



export default {

  name: "General",

  components: {

    RequestTable,

    MiniStatisticsCard,

    ProgressLineChart,

    BarChart,

    ProgressDoughnutChart,

    GaugeChart,

    InsuredsTable,
    InsuredExportPreviewDialog

  },

  data() {

    return {

      image,

      dialogVisible: false,

      mountCount: 0,

      dialogExcelVisible: false,

      requests: [],

      claimLine: null,

      loading: false,

      totalClaim: 0,

      requestsCount: 0,

      refChart: null,

      loadingTable: false,

      insuredCount: null,

      activeInsuredCount: null,

      totalInsureds: null,

      page: 1,

      policyCardAnalitic: { labels: [], values: [] },

      policyNewCardAnalitic: [],

      insureds: [],

      maxRow: 15,

      policy: {},

      exportPreviewVisible: false,

      exportPreviewRows: [],

      exportingExcel: false,

    };

  },

  computed: {

    claimLineChart() {
      if (!this.claimLine || !this.claimLine.length) {
        return { labels: [], data: [] };
      }
      const slice = this.claimLine.slice(0, 12);
      return {
        labels: slice.map((m) => m.monthName || m.MonthName || ""),
        data: slice.map((m) => Number(m.amount ?? m.Amount ?? 0)),
      };
    },

    doughnutHasData() {
      const data = this.doughnutChartConfig?.datasets?.data || [];
      return data.some((value) => Number(value) > 0);
    },

    exportFileName() {
      return `${this.$t("excelInsuredTitle")}.xlsx`;
    },

    doughnutChartConfig() {
      if (!this.refChart || !this.refChart.length) {
        return {
          mainLables: [],
          labels1: [],
          labels2: [],
          datasets: { label: "Projects", data: [] },
        };
      }

      const colors = ["#FF4560", "#008FFB", "#FEB019", "#775DD0", "#00E396", "#00D4FF", "#FF66C4", "#8D6E63", "#4ECDC4", "#546E7A"];
      const items = this.refChart.map((item, index) => ({
        label: item.referralTypeName || item.ReferralTypeName || `Növ ${index + 1}`,
        color: colors[index % colors.length],
        amount: Number(item.amount ?? item.Amount ?? 0),
      }));

      const half = Math.ceil(items.length / 2);

      return {
        mainLables: items.map((x) => ({ label: x.label, color: x.color })),
        labels1: items.slice(0, half).map((x) => ({ label: x.label, color: x.color })),
        labels2: items.slice(half).map((x) => ({ label: x.label, color: x.color })),
        datasets: {
          label: "Projects",
          data: items.map((x) => x.amount),
        },
      };
    },

    barChartPrimary() {
      return {
        labels: this.policyCardAnalitic?.labels || [],
        datasets: {
          label: this.$t("commonNew"),
          data: this.policyNewCardAnalitic || [],
        },
      };
    },

    barChartSecondary() {
      return {
        labels: this.policyCardAnalitic?.labels || [],
        datasets: {
          label: this.$t("commonTerminate"),
          data: this.policyCardAnalitic?.values || [],
        },
      };
    },

    claimHeight() {

      if (this.insureds != null) {

        var length = this.insureds.length



        if (length > 10) length = 10

        if (length < 8) length = 8



        return (510 - 55 * (10 - length)).toString()

      }



      return null

    }

  },

  mounted() {
    this.handleSearch(1, null, null, null, null, null);
    this.onGlobalRefresh = () => {
      this.searchPolicy();
      if (this.page) {
        this.handleSearch(this.page);
      }
    };
    window.addEventListener("app:refresh-data", this.onGlobalRefresh);
  },

  beforeMount() {
    const policyId = Number(getPolicyId(this.$route)) || 0;
    if (!policyId) return;

    const list = {
      id: policyId,
      requestCorrelationId: "string"
    };

    Source.ClaimAnalitics(list)
      .then((responseClaim) => {
        this.claimLine = responseClaim.data.data || [];
        this.totalClaim = (responseClaim.data.data || []).reduce(
          (accumulator, current) => accumulator + Number(current.amount ?? current.Amount ?? 0),
          0
        );
      });

    Source.Policy(list).then((response) => {
      this.policy = response.data.data[0];
      if (this.policy && this.policy.policyId) {
        sessionStorage.setItem("policy", JSON.stringify(this.policy.policyId));
        sessionStorage.setItem(
          "policyNumber",
          JSON.stringify(`${this.policy.policySeries}${this.policy.policyNumber}`)
        );
      }
    });

    if (this.mountCount < 1) {
      this.mountCount = 1;
      this.searchPolicy();
    }
  },

  beforeUnmount() {
    if (this.onGlobalRefresh) {
      window.removeEventListener("app:refresh-data", this.onGlobalRefresh);
    }
  },

  methods: {

    handleSearch(newpage, dateFrom, dateTo, isEmployee, groupId, active, src) {
      const policyId = Number(getPolicyId(this.$route)) || 0;
      if (!policyId) {
        this.insureds = [];
        this.insuredCount = 0;
        this.totalInsureds = 0;
        return;
      }
      this.loadingTable = true;
      this.page = newpage || 1;

      const list = {
        "requestCorrelationId": "string",
        "data": {
          policyId: policyId,
          totalCount: 0,
          totalInusred: 0,
          requestCorrelationId: "string",
          search: "",
          currentPage: this.page,
          maxRow: this.maxRow,
          "startDate": dateFrom || null,
          src: src || null,
          "endDate": dateTo || null,
          "isEmployee": isEmployee === undefined ? null : isEmployee,
          "groupId": groupId || null,
          "active": active === undefined ? null : active
        }
      };

      Source.PolicyCardByPage(list)
        .then((response) => {
          this.insureds = response.data.data || [];
          this.insuredCount = response.data.totalItems || 0;
          this.totalInsureds = response.data.totalInsureds || 0;
          this.loadingTable = false;
        })
        .catch((error) => {
          console.error("Произошла ошибка:", error);
          this.loadingTable = false;
        });
    },

    openExcelPreview() {
      this.exportPreviewRows = mapInsuredRowsForExport(this.insureds);
      this.exportPreviewVisible = true;
    },

    async confirmExcelExport() {
      if (!this.exportPreviewRows.length || this.exportingExcel) {
        return;
      }

      this.exportingExcel = true;

      try {
        await exportStyledTableWorkbook({
          title: this.$t("excelInsuredTitle"),
          fileName: this.exportFileName,
          sheetName: this.$t("excelInsuredSheet"),
          rows: this.exportPreviewRows,
        });
        this.exportPreviewVisible = false;
      } finally {
        this.exportingExcel = false;
      }
    },

    searchPolicy() {
      const policyId = Number(getPolicyId(this.$route)) || 0;
      if (!policyId) return;

      this.loading = true;

      const list = {
        id: policyId,
        requestCorrelationId: "string"
      };



      Source.PolicyCardAnalitic(list)
        .then((responseCard) => {
          const nextAnalitic = { labels: [], values: [] };
          (responseCard.data.data || []).forEach(item => {
            const start = item.startMonthName || item.StartMonthName || "";
            const end = item.endMonthName || item.EndMonthName || "";
            nextAnalitic.labels.push(start && end ? `${start} - ${end}` : (start || end || ""));
            nextAnalitic.values.push(Number(item.amount ?? item.Amount ?? 0));
          });
          this.policyCardAnalitic = nextAnalitic;
        })

      Source.PolicyNewCardAnalitic(list)
        .then((responseNewCard) => {
          const nextNewCards = [];
          (responseNewCard.data.data || []).forEach(item => {
            nextNewCards.push(Number(item.amount ?? item.Amount ?? 0));
          });
          this.policyNewCardAnalitic = nextNewCards;
        })



      Source.ReferralAnalitics(list)

        .then((responseReferral) => {

          this.refChart = responseReferral.data.data;

        })

      Source.AccountRequestsBulkByPolicy(list)
        .then((responseAccount) => {
          this.requests = responseAccount.data?.data || [];
        })

      Source.AccountRequestsBulkCountByPolicy(list)
        .then((responseCount) => {
          this.requestsCount = responseCount.data || 0;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })





    },

    formatDate(dateString) {

      if (!dateString) return "";

      const date = new Date(dateString);



      const day = String(date.getDate()).padStart(2, "0");

      const month = String(date.getMonth() + 1).padStart(2, "0");

      const year = String(date.getFullYear()).slice(2);



      return `${day}.${month}.${year}`;

    },

    perVal() {

      const startDate = new Date(this.policy.startDate);

      const endDate = new Date(this.policy.endDate);

      const currentDate = new Date();



      const totalDuration = endDate - startDate;

      const timeElapsed = currentDate - startDate;

      return (timeElapsed / totalDuration) * 100;

    },

    goToGroups() {

      window.location.href = groupClinicHref(getPolicyId(this.$route))

    },

    closeDialog() {

      this.dialogVisible = false

    }

  }

};

</script>



<style>

.ruf-div {

  display: flex;

  gap: 15px;

}



.main-ruf-div {

  display: flex;

  flex-direction: column;

  margin: 20px;

}



.ruf-div button {

  width: 45%;

  display: flex;

  flex-direction: column;

  justify-content: space-evenly;

  align-items: center;

  height: 64px;

  border: 0px;

}



.ruf-div button i {

  font-size: larger;

}

</style>

